import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  label,
  theme,
  clickAction,
  onDarkBg,
  small,
  iconLeft,
  iconRight
}) => {
  const icons = {
    download: '#download-icon-rebrand',
    close: '#close-icon-rebrand',
    'down arrow': '#down-arrow-icon',
    'up arrow': '#up-arrow-icon',
    'show more': '#show-more-icon-rebrand'
  };

  return (
    <button
      className={[
        'btn-v2',
        `btn--${theme}`,
        onDarkBg ? 'bg-dark' : '',
        small ? 'btn--small' : ''
      ].join(' ')}
      onClick={clickAction}
    >
      <div className="btn-content">
        {iconLeft && (
          <svg viewBox="0 0 60 60">
            <use xlinkHref={`${icons[iconLeft]}`} />
          </svg>
        )}
        <span>{label}</span>
        {iconRight && (
          <svg viewBox="0 0 60 60">
            <use xlinkHref={`${icons[iconRight]}`}/>
          </svg>
        )}
      </div>
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  clickAction: PropTypes.func.isRequired,
  onDarkBg: PropTypes.bool,
  small: PropTypes.bool,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string
};

export default Button;
